import React from 'react';
import { Table, TableHead, TableHeaderCell } from 'src/components';
import { MandateLimits } from 'src/models';
import { SigningRuleTabelRow } from './components';
import { t } from 'i18next';

interface ISigningRules {
  limits: MandateLimits;
}

const SigningRules = ({ limits }: ISigningRules) => {
  return (
    <Table role="table">
      <TableHead role="head">
        <tr role="row">
          <TableHeaderCell
            role="columnheader"
            aria-label={t('MandateProductArea')}
          >
            {t('MandateProductArea')}
          </TableHeaderCell>
        </tr>
      </TableHead>
      <tbody role="rowgroup">
        {limits.map((limit, index) => (
          <SigningRuleTabelRow key={index} limit={limit} />
        ))}
      </tbody>
    </Table>
  );
};

export default SigningRules;
